export const PHONE_NUMBER_REGEX = /\d{9}/;
export const REPLACE_SPACES = / |_/g;
